import { useTranslation } from 'react-i18next';

import { Heading } from '@ctct/presentation-layer';

import { SingleBillPaymentMethodsWidgetContent } from './SingleBillPaymentMethodsWidgetContent';
import type { SingleBillPaymentMethodsWidgetProps } from './useSingleBillPaymentMethodsWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const SingleBillPaymentMethodsWidget = ({
  status,
  data,
  handlers,
  hooks,
}: SingleBillPaymentMethodsWidgetProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Heading>{t('payment-methods.heading')}</Heading>
      <WithStatusHandling
        skeletonHeight={210}
        status={status}
        errorMessage={status === 'error' ? data.message : undefined}
        retry={status === 'error' ? handlers.retry : undefined}
      >
        {status === 'loaded' && <SingleBillPaymentMethodsWidgetContent data={data} handlers={handlers} hooks={hooks} />}
      </WithStatusHandling>
    </>
  );
};
